import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

Vue.config.productionTip = false

new Vue({
  /* ここに登録することで他の場所でインポートすることなく、
  使用可能になる */
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
